module.exports = __webpack_public_path__ + "static/media/IMG_0932.fbce6fa5.JPG";